import LocalizedLink from '@/components/LocalizedLink';
import { ROUTES } from '@/constants/application-urls';
import BrandDefinition from '@/types/BrandDefinition';
import FooterDictionary from '@/types/dictionaries/Footer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material/styles';

const styles = {
	link: {
		fontWeight: 400,
		color: 'white.main',
		':hover': {
			fontWeight: 400,
			color: 'grey.light',
		},
	},
} as const satisfies Record<string, SxProps>;

interface MyAccountSectionProps {
	dict: FooterDictionary;
	brand: BrandDefinition;
	showHeading: boolean;
}

export default function MyAccountSection({ dict, showHeading }: Readonly<MyAccountSectionProps>) {
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '8px' }} data-testid="footer-my-account">
			{showHeading && (
				<Typography variant="paragraphExtraBold" data-testid="footer-my-account-title">
					{dict.accountSection.title}
				</Typography>
			)}
			<LocalizedLink href={ROUTES.ORDERS} sx={{ ...styles.link }} data-testid="footer-orders-link">
				{dict.accountSection.orders}
			</LocalizedLink>
		</Box>
	);
}
